import { Sidebar, Topbar } from "./Shell";
import { OfflineBanner } from "./OfflineBanner";

export function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen w-full bg-canvas">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        {/* Offline banner is a sibling of the topbar so it stays sticky to
            the top of the main content column without pushing the sidebar. */}
        <OfflineBanner />
        <main className="min-w-0 flex-1 px-4 py-6 sm:px-6 lg:px-10 lg:py-8">
          <div className="mx-auto w-full max-w-[1280px]">{children}</div>
        </main>
      </div>
    </div>
  );
}
